import { animate, style, transition, trigger } from '@angular/animations';

export const fadeOutAnimation = (time: string) =>
  trigger('fadeOut', [transition(':leave', [style({ opacity: 1 }), animate(time, style({ opacity: 0 }))])]);
